import React from 'react';

export default function TrustStrip() {
  return (
    <section className="border-y border-white/10 bg-white/[0.03] text-white">
      <div className="mx-auto max-w-7xl px-6 py-8">
        <div className="mb-6 text-center text-sm uppercase tracking-[0.24em] text-white/55">
          Built for brands that want to stay in control
        </div>
        <div className="grid gap-4 md:grid-cols-3">
          {[
            'Keep your store, identity, and pricing',
            'Approve who can represent your products',
            'Pay only when value is actually created',
          ].map((item) => (
            <div
              key={item}
              className="flex min-h-20 items-center justify-center rounded-[22px] border border-white/10 bg-slate-900/70 px-5 py-4 text-center text-sm font-medium leading-6 text-white/80"
            >
              {item}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
